import React, { Component } from "react";
import { burying } from "../../utils/buryPoint";
import { getQueryString } from "../../utils/utils";
import ErrorTip from "../errorTip";
import styles from "./index.less";

interface Props {
  labelName: string;
  fieldName: string;
  is_required?: boolean;
  placeholder?: string;
  maxSize?: number;
  errorTip?: string;
  grayType?: boolean;
  source?: string;
  getValue?: (value: string, type: string) => void;
}

interface State {
  number: number;
  value: string;
}

class ProblemDescription extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      number: 0,
      value: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { grayType } = nextProps;
    if (grayType) {
      this.setState({
        value: "",
        number: 0,
      });
    }
  }

  /**
   * @description 文本框内容改变监听方法
   *
   **/
  textChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { getValue, fieldName } = this.props;
    const text = e.target.value;
    this.setState({
      value: text,
    });
    getValue(text, fieldName);
    if (text.length <= this.props.maxSize) {
      this.setState({
        number: text.length,
      });
    }
  };

  render() {
    const {
      labelName,
      is_required,
      placeholder,
      maxSize,
      errorTip,
      grayType,
      source,
    } = this.props;
    const { number, value } = this.state;
    const punishId = getQueryString("punishId");
    return (
      <div className={styles.problemDescription}>
        <div className={styles.description}>
          <div className={styles.title}>
            {is_required ? <span className={styles.star}>*</span> : null}
            {labelName ? labelName : "问题描述"}：
          </div>
          <div className={styles.textarea}>
            <textarea
              maxLength={maxSize}
              placeholder={placeholder ? placeholder : "描述用户遇到的问题"}
              onChange={this.textChange}
              value={value}
              disabled={grayType}
              onClick={() => {
                source === "bounced"
                  ? burying(
                      "2",
                      "write-appeal-add",
                      `frame=0$punishid=${punishId}`,
                      "ss-05",
                      "undefined"
                    )
                  : burying(
                      "2",
                      "write-appeal-submit",
                      `frame=0$punishid=${punishId}`,
                      "ss-03",
                      "undefined"
                    );
              }}
            />
            <span className={styles.number}>
              {number}/{maxSize}
            </span>
          </div>
        </div>
        {errorTip ? (
          <div className={styles.errorTip}>
            <ErrorTip errorTip={errorTip} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ProblemDescription;
